import { NavLink, Outlet } from 'react-router';
import { cx } from '../../ui/index.tsx';

const TABS = [
  { to: '/configuracion', label: 'Negocio', end: true },
  { to: '/configuracion/ventas', label: 'Ventas y cobros' },
  { to: '/configuracion/cajas', label: 'Cajas' },
  { to: '/configuracion/empleados', label: 'Empleados' },
  { to: '/configuracion/dispositivos', label: 'Dispositivos' },
];

/** Secciones de la configuración: pestañas arriba en el celular; en PC, una columna a la izquierda. */
export function SettingsLayout() {
  return (
    <div className="mx-auto max-w-5xl lg:grid lg:grid-cols-[13rem_minmax(0,1fr)] lg:items-start lg:gap-6">
      <nav className="mb-4 flex gap-1 overflow-x-auto rounded-xl bg-white p-1 shadow-card ring-1 ring-slate-200/80 lg:sticky lg:top-5 lg:mb-0 lg:flex-col lg:overflow-visible lg:bg-transparent lg:p-0 lg:shadow-none lg:ring-0">
        <p className="hidden px-3 pb-2 text-xs font-semibold tracking-wide text-slate-500 uppercase lg:block">Configuración</p>
        {TABS.map((t) => (
          <NavLink
            key={t.to}
            to={t.to}
            end={t.end}
            className={({ isActive }) =>
              cx(
                'flex-1 whitespace-nowrap rounded-lg px-3 py-2 text-center text-sm font-medium transition-colors lg:flex-none lg:text-left',
                isActive
                  ? 'bg-slate-100 text-slate-900 lg:bg-white lg:shadow-card lg:ring-1 lg:ring-slate-200/80'
                  : 'text-slate-600 hover:text-slate-900 lg:hover:bg-white/70',
              )
            }
          >
            {t.label}
          </NavLink>
        ))}
      </nav>
      <div className="min-w-0">
        <Outlet />
      </div>
    </div>
  );
}
